module.exports = __webpack_public_path__ + "img/img-carrusel-personas-1.3d0bc36.webp";